/**
 * Kütüphane tarama durumu listesi (Tasarım V2, Dalga 11).
 *
 * ## Neden ayrı bileşen?
 *
 * "Son Tarama" bilgisi kütüphane ekranındaki istatistik bandından
 * kaldırıldı: kullanıcı kararıyla ilgisi olmayan operasyonel bir log
 * kaydıydı ve içerik sayısıyla eşit ağırlıkta duruyordu. Doğru yeri sistem
 * ekranı.
 *
 * Ayrı bileşen olmasının ikinci nedeni: `AccountScreen` zaten 25 KB'a
 * yakın ve karmaşıklık sınırına dayanmıştı. Veri çekme ve listeleme bu
 * bileşende kalırsa hesap ekranının okunabilirliği düşer.
 */
import type { ReactNode } from 'react';
import { useEffect, useState } from 'react';
import { api, type Library } from '../api.ts';
import { formatDateTime } from '../format.ts';
import { FolderIcon } from '../Icon.tsx';

export function LibraryScanList(): ReactNode {
  const [libraries, setLibraries] = useState<Library[] | null>(null);

  useEffect(() => {
    let cancelled = false;
    void api
      .libraries()
      .then((list) => {
        if (!cancelled) setLibraries(list);
      })
      .catch(() => {
        if (!cancelled) setLibraries([]);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (libraries === null || libraries.length === 0) return null;

  return (
    <section className="account__card account__card--compact">
      <div className="account__card-header">
        <div className="account__card-icon">
          <FolderIcon size={20} />
        </div>
        <div>
          <h3 className="account__card-title">Kütüphane Taramaları</h3>
          <p className="account__card-desc">
            Katalogun son kez ne zaman tarandığı ve kaç içerik bulunduğu
          </p>
        </div>
      </div>

      <div className="account__spec-list">
        {libraries.map((library) => (
          <div className="account__spec-item" key={library.id}>
            <span className="account__spec-label">{library.name}</span>
            <span className="account__spec-val">
              {library.scannedAt !== null ? (
                <>
                  {formatDateTime(library.scannedAt)} · {library.itemCount} içerik
                </>
              ) : (
                'Henüz taranmadı'
              )}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
